/*
 * iurop-about — Easter egg: arrastrar los vectores decorativos (estrellas y
 * nubes) con el ratón / dedo. Al cogerlos se les desactiva la animación y se
 * traen al frente; quedan donde los sueltes. Sin dependencias.
 */
(function () {
  function initDeco(el) {
    var startX = 0,
      startY = 0,
      baseX = 0,
      baseY = 0,
      dragging = false;

    el.setAttribute('draggable', 'false');
    el.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true;
      startX = e.clientX;
      startY = e.clientY;
      el.classList.add('kawaii-about__deco--free');
      try {
        el.setPointerCapture(e.pointerId);
      } catch (_) {}
      e.preventDefault();
    });

    el.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = baseX + (e.clientX - startX);
      var dy = baseY + (e.clientY - startY);
      el.style.transform = 'translate(' + dx + 'px, ' + dy + 'px)';
    });

    function end(e) {
      if (!dragging) return;
      dragging = false;
      baseX += e.clientX - startX;
      baseY += e.clientY - startY;
      try {
        el.releasePointerCapture(e.pointerId);
      } catch (_) {}
    }
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
  }

  // Cuenta ascendente de los números de stats al entrar en pantalla.
  function animateNumbers(section) {
    if (!section.classList.contains('kawaii-about--animate')) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var values = section.querySelectorAll('.kawaii-about__stat-value');
    if (!values.length) return;

    function run() {
      values.forEach(function (el) {
        var raw = (el.textContent || '').trim();
        var m = raw.match(/^([0-9]+(?:[.,][0-9]+)?)(.*)$/);
        if (!m) return;
        var target = parseFloat(m[1].replace(',', '.'));
        var suffix = m[2];
        var dp = (m[1].split(/[.,]/)[1] || '').length;
        var dur = 1300,
          t0 = null;
        el.style.minWidth = el.offsetWidth + 'px'; // fija el ancho final (sin saltos)
        function step(t) {
          if (t0 === null) t0 = t;
          var p = Math.min((t - t0) / dur, 1);
          var e = 1 - Math.pow(1 - p, 3); // easeOutCubic
          el.textContent = (target * e).toFixed(dp) + suffix;
          if (p < 1) {
            requestAnimationFrame(step);
          } else {
            el.textContent = raw;
            el.style.minWidth = '';
          }
        }
        requestAnimationFrame(step);
      });
    }

    var anchor = section.querySelector('.kawaii-about__stats') || section;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              io.disconnect();
              run();
            }
          });
        },
        { threshold: 0.4 }
      );
      io.observe(anchor);
    } else {
      run();
    }
  }

  // Carrusel de fotos (corrección cliente #1). Solo se activa con 2+ fotos.
  function initCarousel(section) {
    var root = section.querySelector('[data-about-carousel]');
    if (!root || root.dataset.aboutCarouselInit) return;
    var track = root.querySelector('[data-about-track]');
    var slides = root.querySelectorAll('.kawaii-about__slide');
    if (!track || slides.length < 2) return;
    root.dataset.aboutCarouselInit = '1';

    var prev = root.querySelector('[data-about-prev]');
    var next = root.querySelector('[data-about-next]');
    var dotsWrap = root.querySelector('[data-about-dots]');
    var dots = [];
    if (dotsWrap) {
      for (var i = 0; i < slides.length; i++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'kawaii-about__dot';
        d.setAttribute('aria-label', 'Ir a la foto ' + (i + 1));
        (function (idx) {
          d.addEventListener('click', function () { goTo(idx); });
        })(i);
        dotsWrap.appendChild(d);
        dots.push(d);
      }
    }

    function pitch() {
      return Math.round(slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left) || track.clientWidth;
    }
    function current() {
      return Math.round(track.scrollLeft / (pitch() || 1));
    }
    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * pitch(), behavior: 'smooth' });
    }

    var raf = 0;
    function update() {
      raf = 0;
      var i = current();
      if (prev) prev.hidden = track.scrollLeft <= 2;
      if (next) next.hidden = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      dots.forEach(function (dot, di) {
        dot.classList.toggle('is-active', di === i);
        dot.setAttribute('aria-current', di === i ? 'true' : 'false');
      });
    }
    track.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });
    window.addEventListener('resize', update);

    // Autoplay suave: respeta reduced-motion, pausa en interacción y fuera de pantalla.
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null;
    function tick() {
      var i = current();
      goTo(i >= slides.length - 1 ? 0 : i + 1);
    }
    function play() { if (reduce || timer) return; timer = setInterval(tick, 5000); }
    function pause() { if (timer) { clearInterval(timer); timer = null; } }
    root.addEventListener('pointerenter', pause);
    root.addEventListener('pointerleave', play);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', play);
    document.addEventListener('visibilitychange', function () { if (document.hidden) { pause(); } else { play(); } });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { play(); } else { pause(); } });
      }, { threshold: 0.3 });
      io.observe(root);
    } else {
      play();
    }

    update();
  }

  function initSection(section) {
    if (!section || section.dataset.kaDragInit) return;
    section.dataset.kaDragInit = '1';
    section.querySelectorAll('.kawaii-about__deco').forEach(initDeco);
    animateNumbers(section);
    initCarousel(section);
  }

  function boot() {
    document.querySelectorAll('.kawaii-about').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Editor de temas: re-inicializa al recargar la sección.
  document.addEventListener('shopify:section:load', function (e) {
    initSection(e.target.querySelector('.kawaii-about'));
  });
})();
